<template>
<div class="scale2"
     :style="scaleStyle"
     ref="previewMain">
  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-01'">
    <div class="flex">
      <div class="rirekisho-box1">
        <div class="rirekisho-header">
          <div class="title slim">履歴書</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 現在
          </div>
        </div>
        <div class="rirekisho-profile"
             @click="$eventHub.$emit('go-card-to', 'profile')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>
          </div>
          <div class="name slim flex">
            <div class="label">名前</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc slim flex">
            <div class="birthday" :style="formatData.selFontStyle"> <span class="year">{{ basicData.birthYear }}</span>年 <span class="month">{{ basicData.birthMonth }}</span>月 <span class="day">{{ basicData.birthDay }}</span>日生（満 <span class="age">{{ age }}</span> 歳）</div>
            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">男</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">女</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-photo"
           @click="$eventHub.$emit('go-card-to', 'id-photo')">
        <div v-if="basicData.idPhotoSrc">
          <img :src="basicData.idPhotoSrc"
               alt="証明写真">
        </div>
        <div v-else>
          <div class="rirekisho-photo-inner">
            <p>証明写真
              <br>縦 36mm～40mm
              <br>横 24mm～30mm
              <br>本人単身胸から上
              <br>裏面のりづけ
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             @click="$eventHub.$emit('go-card-to', 'address')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input" ref="addressFurigana"
                 :class="classObject.addressFurigana" :style="formatData.selFontStyle">{{ basicData.addressFurigana }}</div>
          </div>
          <div class="address flex">
            <div class="label">現住所</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">&#12306;{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre :style="formatData.selFontStyle">{{ basicData.address1}} {{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             @click="$eventHub.$emit('go-card-to', 'contacts')">
          <div class="tel flex">
            <div class="label">電話</div>
            <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-table rirekisho-table-slim rirekisho-new-history-1"
         @click="$eventHub.$emit('go-card-to', 'edu-history')">
      <table :class="{error:this.errorMessages.eduJobHistory}">
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>学歴</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable4New"
              v-bind:class="item.classObject"
              v-if="index <= 6"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="rirekisho-table rirekisho-table-slim rirekisho-skill"
         @click="$eventHub.$emit('go-card-to', 'license-history')"
         :id="idPrefix + 'preview-page-02'">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>免許・資格</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index <= 3"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-pr-slim">
      <div class="rirekisho-pr-reason-new-single"
           @click="$eventHub.$emit('go-card-to', 'reasonNew')">
        <div class="label">自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど</div>
        <div class="input">
          <pre ref="reasonNew"
               :class="classObject.reasonNew" :style="formatData.selFontStyle">{{ formatData.reasonNew }}</pre>
        </div>
      </div>
      <div class="rirekisho-pr-etc"
           @click="$eventHub.$emit('go-card-to', 'others')">
        <div class="time">
          <div class="label">通勤時間</div>
          <div class="input text-right" v-if="formatData.commuteHours || formatData.commuteMinutes" :style="formatData.selFontStyle">約 <template v-if="formatData.commuteHours"><span>{{ formatData.commuteHours }}</span> 時間</template> <template v-if="formatData.commuteMinutes"><span>{{ formatData.commuteMinutes }}</span> 分</template></div>
        </div>
        <div class="family">
          <div class="label">扶養家族数（配偶者を除く）</div>
          <div class="input text-right" :style="formatData.selFontStyle"><span>{{ formatData.spouseNumber }}</span> 人</div>
        </div>
        <div class="partner">
          <div class="existence">
            <div class="label">配偶者</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.hasSpouse}">有</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.hasSpouse}">無</span></div>
          </div>
          <div class="support">
            <div class="label">配偶者の扶養義務</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.underDutyToSupport}">有</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.underDutyToSupport}">無</span></div>

          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-new-hope-slim"
         @click="$eventHub.$emit('go-card-to', 'requests')">
      <div class="label">本人希望欄</div>
      <div class="input">
        <pre ref="request"
             :class="classObject.request" :style="formatData.selFontStyle">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/rirekisho-preview-mixin'
export default {
  name: 'rirekishoSinglePreview',
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 8,
      maxLicenseRows: 4,
      textareaMaxHeights: {
        reason: 180,
        reasonNew: 160,
        request: 70
      },
      optionItems: {
        commuteDescription: false
      }
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  }
}
</script>
